import zoomImage from '../Images/intro-zoom.svg';
import clickImage from '../Images/disclaimer-click.png';
import filterImage from '../Images/filter.svg';
import searchImage from '../Images/tools-search.svg';

// Main configuration
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZ3JlZW5wZWFjZWdtaCIsImEiOiJjbG81ejU2bTcwZ3QxMmhwaGk1MmRleTZrIn0.O06H3YWlSVNujXdrzgga1Q';
export const DEFAULT_COORDS = [-35, 15];
export const DEFAULT_ZOOM = 2;
export const DEFAULT_LANG = 'en';
export const CACHE_LIFETIME = 24*3600000; // 24 hours

export const GOOGLE_DATA_SPREADSHEET_ID = '1MzkXYotK8iR7ClVr-yKkqM9w_D_FLeNskwKPddxcOD4';
export const GOOGLE_LANGUAGES_SPREADSHEET_ID = '1z1AnvJjYm4qVR1e_PAYLDqotZ6sCaMtImT990JfnFDY';

export const FILTER_GROUPS = ['other', 'movement_types'];

// layer controls
export const POINT_LAYER_ID = 'points';
export const POINT_LAYER_SRC = `${POINT_LAYER_ID}_src`;
export const POINT_LAYER_HIDDEN_CLUSTERS = `hidden_clusters`;

// clustering params
export const MAX_CLUSTER_ZOOM = 15;
export const SPIDER_CIRCUMFERENCE = 35;

// local storage params
export const LOCAL_STORAGE_TOKEN = 'gpint-umm-intro-hide';

// images
export { zoomImage, clickImage, filterImage, searchImage };
